import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Eras from "./components/Eras";
import HotWorks from "./components/HotWorks";
import RareArchive from "./components/RareArchive";
import About from "./components/About";
import FAQ from "./components/FAQ";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Eras />
        <HotWorks />
        <RareArchive />
        <About />
        <FAQ />
      </main>
      <Footer />
    </>
  );
}